module.exports = {
	"TPL_CATEGORY": {
		"RECOMMEND": "1",
		"RP_H5": "2",
		"RP_SPA": "3",
		"RP_VIDEO": "4",
		"VIP": "5",
		"ENTERPRISE": "6",
		"MY_TPL": "7",
		"MY_COLLECTION": "7",
		"CONTENT_TOPICS": "8",
		"SEARCH": "9",
		"RP_GAME": "10"
	},
	"TPL_TYPE": {
		"RP_H5": "1",
		"RP_SPA": "2",
		"RP_VIDEO": "3",
		"RP_GAME": "4"
	}
}